module.exports = __webpack_public_path__ + "static/media/vector-4966.cc681f41.svg";